import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';

const service = new SettingsService();

/** ----------------------------------------------------------------------------
 * SAVE MESSAGE VIA
 -----------------------------------------------------------------------------*/

export const saveMessageViaRequested = () => ({
  type: SettingsActionTypes.SAVE_MESSAGES_VIA_REQUESTED,
  isChangingVia: true,
});

export const saveMessageViaSuccess = response => ({
  type: SettingsActionTypes.SAVE_MESSAGES_VIA_SUCCESS,
  isChangingVia: false,
  isSuccess: response.isSuccess,
  message: response.message,
});

export const saveMessageViaFailure = error => ({
  type: SettingsActionTypes.SAVE_MESSAGES_VIA_FAILURE,
  isChangingVia: false,
  error: true,
  status: error.response && error.response.status,
});

export default function saveMessageVia(type) {
  return (dispatch) => {
    dispatch(saveMessageViaRequested());

    return service.messagesVia(type).then(
      response => dispatch(saveMessageViaSuccess(response.data)),
      error => dispatch(saveMessageViaFailure(error)),
    );
  };
}